module.exports = __webpack_public_path__ + "static/navLogoKvet-1ea603b5deda15cfc15b441e6946c19c.png";